<template>
  <el-config-provider :locale="elemntLibLocale">
    <component :is="layout" />
  </el-config-provider>
  <div v-if="appLoading" v-loading="true" class="page-loader"></div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { AXIOS_CLIENT } from "@/config/api-service-client.js";

import { DEFAULT_LOCALE } from "@/config/variables.js";

import AuthLayout from "@/layouts/AuthLayout.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import LayoutSubscribe from "@/layouts/LayoutSubscribe.vue";
import LayoutError from "@/layouts/LayoutError.vue";

import enLocale from "element-plus/dist/locale/en.min.mjs";
import frLocale from "element-plus/dist/locale/fr.min.mjs";

export default {
  name: "App",
  components: { AuthLayout, DefaultLayout, LayoutError, LayoutSubscribe },
  computed: {
    ...mapGetters(["currentUser", "getAppLanguage"]),
    layout() {
      return this.$route.meta.layout || "";
    },
    elemntLibLocale() {
      return this.getAppLanguage === "fr" ? frLocale : enLocale;
    },
  },
  methods: {
    ...mapActions([
      "stayLogIn",
      "APP_SERVER_PARAMS",
      "DEFAULT_APP_LOGO_MOTTO",
      "logOut",
    ]),
    async appInit() {
      this.$router.isReady().then(async () => {
        if (this.layout !== "LayoutSubscribe") await this.stayLogIn();
        const client_name = this.$route.params.client_name;
        if (client_name) {
          this.$store.commit("MUTATE_SELECTED_CWS", client_name);
          await this.APP_SERVER_PARAMS();
        }
      });
    },
  },
  watch: {
    // async $route(newVal, oldVal) {
    //   const client_name = newVal.params.client_name;
    //   const oldClientName = oldVal.params.client_name;

    //   if (client_name && oldClientName !== client_name) {
    //     this.$store.commit("MUTATE_SELECTED_CWS", client_name);
    //     await this.APP_SERVER_PARAMS();
    //   }
    //   // const context_key = newVal.params.context_key;
    //   // const oldContextKey = oldVal.params.context_key;
    //   // if (context_key && oldContextKey !== context_key) {
    //   //   this.$store.commit("MUTATE_SELECTED_ATU", context_key);
    //   //   await this.APP_SERVER_PARAMS();
    //   // }
    // },
    // appLanguage: {
    //   immediate: true,
    //   handler(newVal) {
    //     if (newVal) return (this.$i18n.locale = newVal);
    //     this.$i18n.locale = DEFAULT_LOCALE;
    //   },
    // },
    getAppLanguage: {
      immediate: true,
      handler(val) {
        switch (val) {
          case "fr":
            this.$i18n.locale = "fr";
            this.$moment.locale("fr");
            break;
          default:
            this.$i18n.locale = DEFAULT_LOCALE;
            this.$moment.locale("en");
            break;
        }
      },
    },
  },
  data() {
    return {
      notificationAllow: true,
      activityTimeOut: null,
      appLoading: true,
    };
  },
  async created() {
    await this.appInit();
    await this.DEFAULT_APP_LOGO_MOTTO();

    // console.log("$route", this.$route.params);
    this.appLoading = false;
    AXIOS_CLIENT.interceptors.response.use(undefined, (error) => {
      if (error.response && error.response.status === 404) {
        if (this.notificationAllow) {
          // this.notificationAllow = false;
          this.$message({
            message: "Url not found",
            type: "error",
          });
        }
      }
      throw error;
    });
  },
};
</script>

<style lang="scss">
.error__page,
.subscribe__page {
  max-width: 760px;
  width: 100%;
  margin: 1em auto;
  padding: 1em 2em;
  border-radius: 10px;
  background-color: #fff;
}
.page-loader {
  width: 100%;
  height: 100%;
  position: fixed !important;
  --el-loading-spinner-size: 200px;
  :deep() .el-loading-mask {
    background: none;
  }
}

// $offset: 10px;
// .sidebar__info {
//   padding: 10px 0 0;
//   margin: 0 (-$offset) 20px;
//   list-style: none;
//   word-break: break-word;
//   a {
//     word-break: break-word;
//   }
//   & > li {
//     display: grid;
//     grid-template-columns: 1fr 1fr;
//     padding: 10px $offset;
//     &.logo {
//       display: block;
//       text-align: center;
//       .title {
//         padding-right: 0;
//         padding-bottom: 15px;
//         display: block;
//         text-align: center;
//         max-width: 50%;
//         text-align: right;
//         padding-right: 15px;
//       }
//     }
//     &:first-child:not(:last-child) {
//       border-bottom: 1px solid #0646ae;
//       margin-bottom: 10px;
//     }
//     &:first-child {
//       .text {
//         text-transform: uppercase;
//       }
//     }
//   }
//   .title {
//     flex: 0 0 125px;
//     text-align: right;
//     color: #0646ae;
//     padding-right: 15px;
//     &.ttc {
//       text-transform: capitalize;
//     }
//     &:after {
//       content: ":";
//     }
//   }
//   .text {
//     display: block;
//     text-align: left;
//     word-break: break-word;
//   }
// }
</style>
